import script from "./TopHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopHeader.vue?vue&type=script&lang=ts&setup=true"

import "./TopHeader.vue?vue&type=style&index=0&id=a1752b96&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1752b96"]])

export default __exports__